import { useRef } from "react";
import Contactimg from "../../assets/images/contact.png";
import "./contactimg.scss";

const ContactImg = () => {
  const bgRef = useRef();
  const solidLogoRef = useRef();

  return (
    <div className="cntct-container" style={{ zIndex: -1 }} ref={bgRef}>
      <img
        draggable={false}
        className="solid-logo"
        ref={solidLogoRef}
        src={Contactimg}
        alt="contact"
      />
    </div>
  );
};

export default ContactImg;
